<div class="header-section">
    <div class="logo-box">
        <img src="../../../../assets/images/entireonhire-logo.svg" alt="">
    </div>
</div>
<form id="form1" class="link-expire-container">
        <div class="link-expire" >
            <img src="../../../../assets/images/link-expire-icon.png"  />
            <h3>Link Expired</h3>
            <p>The password reset request link has expired.<br /> Please click <strong>'Back to Login'</strong> button. From the Login screen, 
                click <strong>'Forgot Password?'</strong> to reset your password or contact your agency staff for further assistance.</p>
            <a href="/login" Class="back-login">Back to Login</a>
        </div>
</form>